export const TargetGroups = [
  'Förskola 1-2 år',
  'Förskola 3-5 år',
  'Årskurs F-3',
  'Årskurs 4-6',
  'Årskurs 7-9',
  'Gymnasiet',
  '19 - 25 år',
  'Offentlig föreställning',
]

export const venueOptions = ['Slöjdsal hård slöjd', 'Slöjdsal mjuk slöjd', 'Utomhus', 'Klassrum eller motsvarande']
